import React from 'react';
import PropTypes from 'prop-types';

const MicrophoneIcon = ({ className }) => (
  <svg
    className={className}
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="Microphone"
  >
    <path d="M12 15.5C13.933 15.5 15.5 13.933 15.5 12V6C15.5 4.067 13.933 2.5 12 2.5C10.067 2.5 8.5 4.067 8.5 6V12C8.5 13.933 10.067 15.5 12 15.5Z" stroke="currentColor" strokeWidth="1.8" />
    <path d="M6 11.5V12C6 15.314 8.686 18 12 18C15.314 18 18 15.314 18 12V11.5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    <path d="M12 18V21" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);

MicrophoneIcon.propTypes = {
  className: PropTypes.string
};

MicrophoneIcon.defaultProps = {
  className: ''
};

export default MicrophoneIcon;
